// src/actions/index.js
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const FETCH_MACHINES_REQUEST = 'FETCH_MACHINES_REQUEST';
export const FETCH_MACHINES_SUCCESS = 'FETCH_MACHINES_SUCCESS';
export const FETCH_MACHINES_FAILURE = 'FETCH_MACHINES_FAILURE';
export const SET_ACCESS_PERMISSIONS = 'SET_ACCESS_PERMISSIONS';
export const SELECT_SUBMENU = 'SELECT_SUBMENU';
export const FETCH_ORDERS_REQUEST = 'FETCH_ORDERS_REQUEST';
export const FETCH_ORDERS_SUCCESS = 'FETCH_ORDERS_SUCCESS';
export const FETCH_ORDERS_FAILURE = 'FETCH_ORDERS_FAILURE';
export const FETCH_TASKTYPE_SUCCESS = 'FETCH_TASKTYPE_SUCCESS';
export const SET_USER = 'SET_USER';
export const SET_DATA = 'SET_DATA';

export const setData = (data) => ({
  type: SET_DATA,
  payload: data,
});

export const setUser = (user) => ({
  type: SET_USER,
  payload: user,
});

export const setAccessPermissions = (permissions) => ({
  type: SET_ACCESS_PERMISSIONS,
  payload: permissions,
});

export const loginSuccess = (user) => ({
  type: LOGIN_SUCCESS,
  payload: user
});

export const loginFailure = (error) => ({
  type: LOGIN_FAILURE,
  payload: error
});

export const fetchTaskTypeSuccess = (task) => ({
  type: FETCH_TASKTYPE_SUCCESS,
  payload: task,
});

export const fetchMachines = () => ({
  type: FETCH_MACHINES_REQUEST,
});

export const fetchMachinesSuccess = (machines) => ({
  type: FETCH_MACHINES_SUCCESS,
  payload: machines,
});

export const fetchMachinesFailure = (error) => ({
  type: FETCH_MACHINES_FAILURE,
  payload: error,
});

export const selectSubMenu = (submenu) => ({
  type: SELECT_SUBMENU,
  payload: submenu,
});

export const fetchOrders = () => ({
  type: FETCH_ORDERS_REQUEST
});

export const fetchOrdersSuccess = (orders) => ({
  type: FETCH_ORDERS_SUCCESS,
  payload: orders,
});

export const fetchOrdersFailure = (error) => ({
  type: FETCH_ORDERS_FAILURE,
  payload: error,
});
